<div class="main" [fui-column-width]="150" [columns]="2">
    <ng-content></ng-content>
</div>
